export default {"src":"/_next/static/media/security-badge.63b248a5.svg","height":50,"width":200,"blurWidth":0,"blurHeight":0};